import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
  templateGenerationSettings: { data: null, loading: false, error: null },
};

const templateGenerationSettingsSlice = createSlice({
  name: 'templateGenerationSettingsComponentState',
  initialState,
  reducers: {
    requestTemplateGenerationSettings(state, action: PayloadAction<any>) {
      state.templateGenerationSettings.loading = true;
      state.templateGenerationSettings.error = null;
    },
    requestTemplateGenerationSettingsSuccess(state, action: PayloadAction<any>) {
      state.templateGenerationSettings.data = action.payload;
      state.templateGenerationSettings.loading = false;
    },
    requestTemplateGenerationSettingsError(state, action: PayloadAction<any>) {
      state.templateGenerationSettings.error = action.payload;
      state.templateGenerationSettings.loading = false;
    },
    requestUpdateTemplateGenerationSettings(state, action: PayloadAction<any>) {
      state.templateGenerationSettings.loading = true;
      state.templateGenerationSettings.error = null;
    },
    requestUpdateTemplateGenerationSettingsSuccess(state) {
      state.templateGenerationSettings.loading = false;
    },
    requestUpdateTemplateGenerationSettingsError(
      state,
      action: PayloadAction<any>,
    ) {
      state.templateGenerationSettings.error = action.payload;
      state.templateGenerationSettings.loading = false;
    },
  },
});

export const {
  actions: templateGenerationSettingsActions,
  reducer,
  name: sliceKey,
} = templateGenerationSettingsSlice;
